import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'

import './App.css';
import { ThemeProvider } from '@mui/system';
import theme from './const/theme';

import DefaultPage from './pages/Default';
import TermsPage from './pages/Terms';
import PrivacyPage from './pages/Privacy';
import GetRegisteredPage from './pages/GetRegistered';
import GetDeletedPage from './pages/GetDeleted';
import DriversPage from './pages/Drivers';
import HostsPage from './pages/Hosts';
import PlansPage from './pages/Plans';
import GiveAwayPage from './pages/GiveAway';
import WhySplitevPage from './pages/WhySplitev';
import AboutSplitevPage from './pages/AboutSplitev';
import AOS from 'aos';
import 'aos/dist/aos.css';

function App() {
  AOS.init();

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route exact path='' element={<DefaultPage />} />
          <Route exact path='/privacy-policy' element={<PrivacyPage />} />
          <Route exact path='/terms-of-service' element={<TermsPage />} />
          <Route exact path='/drivers' element={<DriversPage />} />
          <Route exact path='/hosts' element={<HostsPage />} />
          {/* <Route exact path='/plans' element={<PlansPage />} /> */}
          <Route exact path='/why-splitev' element={<WhySplitevPage />} />
          <Route exact path='/get-registered' element={<GetRegisteredPage />} />
          <Route exact path='/delete-my-record' element={<GetDeletedPage />} />
          {/* <Route exact path='/give-away' element={<GiveAwayPage />} /> */}
          <Route exact path='/about-splitev' element={<AboutSplitevPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>

  );
}

export default App;
